import React, { useState, useEffect } from "react";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import store from "../../redux/store/store";
import "./style.scss";
import { canUseDOM } from "../../utils";
// Import the authentication provider which holds the default settings
import { authProvider } from "../../services/authProvider";
import SampleAppRedirectOnLaunch from "./redirect-on-launch";
import Heading from "../../elements/heading";
import Dropdown from "../../elements/dropdown";
import PrimaryButton from "../../elements/primary-button";
import { setStore } from "../../redux/actions/actions";
import { connect } from "react-redux";
import { getStoreInfo, getStores } from "../../services/storeService";
import { setStaffInfoAction } from "../../redux/actions";

const StaffSignin = ({ rendering, fields, setStoreInfo, setStaffInfo }) => {
  const { headingBody, storeSelectorLabel, cta } = fields;

  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState();
  const [storedStore, setStoredStore] = useState();

  const onStoreChange = value => {
    setSelectedStore(value);
  };
  const submitStoreSelection = () => {
    setStoreInfo(selectedStore);
  };

  useEffect(() => {
    getStoreList();
  }, []);

  useEffect(() => {
    let _storedStore = getStoreInfo();
    if (stores.find(s => s.code === _storedStore?.code)) {
      setStoredStore(_storedStore);
      setSelectedStore(_storedStore);
    }
  }, [stores]);

  const getStoreList = async () => {
    const list = await getStores();
    const _stores = list.map(e => ({
      value: e.storeName,
      code: e.storeCode
    }));
    setStores(_stores);
  };

  const subjectProps = {
    placeholder: storeSelectorLabel?.value,
    options: stores,
    selectedOption: storedStore,
    // showError: this.state.subjectShowError,
    // warningMessage: this.state.subjectWarningMessage,
    onChange: value => onStoreChange(value)
  };

  if (!canUseDOM()) return null;
  return (
    <AzureAD provider={authProvider} reduxStore={store} datasourceid={rendering.dataSource}>
      {({ accountInfo, authenticationState }) => {
        setStaffInfo(accountInfo);
        return (
          <React.Fragment>
            {authenticationState === AuthenticationState.Unauthenticated && (
              <div className="staff-signin">
                <SampleAppRedirectOnLaunch accountInfo={accountInfo} />
              </div>
            )}
            {authenticationState === AuthenticationState.Authenticated && (
              <div className="store-selector grid">
                <div className="content">
                  <Heading html={headingBody} className="title" typographyClass="type-h2" />
                  <Dropdown {...subjectProps} />
                  <PrimaryButton
                    {...{
                      ...cta.fields,
                      buttonText: cta.fields.buttonText.value,
                      callback: () => submitStoreSelection()
                    }}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        );
      }}
    </AzureAD>
  );
};
const mapDispatchToProps = dispatch => ({
  setStoreInfo: data => dispatch(setStore(data)),
  setStaffInfo: data => dispatch(setStaffInfoAction(data))
});
export default connect(null, mapDispatchToProps)(StaffSignin);
